import * as _ from 'lodash';
import { Message } from './message.model';
import { MessageInterface } from './message.interface';

export class MessageFactory {

    static empty(): Message {
        return new Message('', '', '', false, '', '', '', {}, [], false, false, false, false, undefined, undefined, undefined, undefined, undefined,  undefined, [], [], [], '');
    }

    static fromObject(raw: MessageInterface | any): Message {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new Message(
            raw.id,
            raw.group,
            raw.category,
            raw.isRead,
            raw.title,
            raw.text,
            raw.folder,
            raw.user,
            raw.users ? _.map(raw.users, (user) => {
                user.date = user.date && user.date._seconds ? new Date(user.date._seconds * 1000) : user.date;
                user.sendDate = user.sendDate && user.sendDate._seconds ? new Date(user.sendDate._seconds * 1000) : user.sendDate;
                return user;
            }) : raw.users,
            raw.sendAsEmail,
            raw.receiversCanNotAnswer,
            raw.canAnswer,
            raw.canReadAnswer,
            raw.date && raw.date._seconds ? new Date(raw.date._seconds * 1000) : raw.date,
            raw.updateDate && raw.updateDate._seconds ? new Date(raw.updateDate._seconds * 1000) : raw.updateDate,
            raw.source,
            raw.audio,
            raw.image,
            raw.document,
            raw.images,
            raw.documents,
            raw.documentNames,
            raw.documentName,
            raw.roles,
            raw.groups,
            raw.isImportant,
            raw.isNotifySecret,
            raw.regarding,
            raw.textDelta || '',
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/messages/shared/message.factory.ts